import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { OnLoadSelect } from "../../../Components/StatesForComponets";
import "moment/locale/es";
import moment from "moment";
moment.locale("es");

const styles = (theme) => ({
  paper: {
    width: "100%",
    overflow: "auto",
  },
  Table: {
    width: "100%",
    marginBottom: "8px",
  },
  event: {
    width: "98%",
    //height: "98%",
    margin: "1%",
  },
  Grid: {
    width: "98%",
    //height: "98%",
    padding: "1%",
  },
  text: {
    width: "60%",
    margin: "3px",
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
class SelectedCity extends React.Component {
  constructor(props) {
    super(props);
    this.state = { List: [] };
  }
  componentDidMount = async () => {};

  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.Table}>
        {this.props.ListOfCities.length > 0
          ? [
              <FormControl className={classes.Table}>
                <InputLabel id="demo-simple-select-label">
                  Lista de Ciudades
                </InputLabel>
                <Select
                  value={this.props.CitySelected}
                  onChange={(event) => {
                    this.props.sentoParent("cityUuid", event.target.value);
                    if (this.props.getLocalPlaces) {
                      this.props.getLocalPlaces(event.target.value);
                    }
                  }}
                >
                  {this.props.ListOfCities.map((city, index) => {
                    return (
                      <MenuItem value={city.uuid} key={city.uuid}>
                        {city.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>,
            ]
          : [
              this.props.hasState ? (
                <OnLoadSelect />
              ) : (
                <FormControl className={classes.Table}>
                  <InputLabel id="demo-simple-select-label">
                    Municipio
                  </InputLabel>
                  <Select>
                    <MenuItem value={0} key={0}>
                      Seleccione un estado primero
                    </MenuItem>
                  </Select>
                </FormControl>
              ),
            ]}
      </Grid>
    );
  }
}

export default withStyles(styles)(SelectedCity);
